module.exports = __webpack_public_path__ + "static/media/service2.93a1710f.webp";